module.exports = __webpack_public_path__ + "static/media/Lobb-Logo.33856505.png";